import { Action, AnyAction, configureStore, ThunkAction, ThunkDispatch } from '@reduxjs/toolkit';
import authSlice from './AuthSlice';
import sidebarSlice from './SidebarSlice';
import receiptsSlice from './ReceiptsSlice';
import userSlice from './UserSlice';
import appSlice from './AppSlice';
import organizationSlice from './OrganizationSlice';
import assetsSlice from './AssetsSlice';
import balanceSlice from './BalanceSlice';
import transactionSlice from "./TransactionSlice";
import purchasesSlice from "./PurchaseSlice";
import depositsSlice from "./DepositsSlice";
import walletSlice from "./WalletSlice";
import involicesSlice from "./InvoicesSlice";
import toastSlice from "./ToastSlice";
import supplierSlice from "./SuppliersSlice";
import supplierReceiptsSlice from "./SupplierReceiptsSlice";
import depositAccountSlice from "./DepositAccountSlice";
import repassesSlice from "./RepassesSlice";
import enviosSlice from "./EnviosSlice";
import { Api } from '../services/Api';
import axios from 'axios';
import { configUrl, env } from '../config/config';

export const store = configureStore({
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    reducer: {
        app: appSlice,
        auth: authSlice,
        sidebar: sidebarSlice,
        receipts: receiptsSlice,
        user: userSlice,
        assets: assetsSlice,
        organization: organizationSlice,
        balance: balanceSlice,
        transaction: transactionSlice,
        purchase: purchasesSlice,
        deposit: depositsSlice,
        wallet: walletSlice,
        invoice: involicesSlice,
        toast: toastSlice,
        supplier: supplierSlice,
        supplierReceipts: supplierReceiptsSlice,
        depositAccount: depositAccountSlice,
        repasses: repassesSlice,
        envios: enviosSlice,
    },
});

export type AppThunkDispatcher = ThunkDispatch<RootState, unknown, Action<string>>;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    AnyAction
>

export const setupApplication = async (): Promise<void> => {
    await axios.get(configUrl)
        .then((resp) => {
            env.config = (resp.data);
        })
        .catch(e => {
            console.log("no config found " + e)
        });

    if (env.config.mock === true || process.env.REACT_APP_MOCK === 'true' || process.env.REACT_APP_MOCK === '1') {
        env.config = { ...env.config, mock: true };
        const { enableApiMocks } = await import('../mocks');
        enableApiMocks();
        console.info('[ttop-app] mock API interceptors enabled');
    }

    Api.setDispatcher(store.dispatch);
};